var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter-text"},[_c('div',{staticClass:"counter-text_number"},[_c('counter-increase',{attrs:{"count_to":_vm.count_to_number}}),_vm._v(_vm._s(_vm.add_plus_symbol ? '+' : '')+"\n  ")],1),_vm._v(" "),_c('div',{staticClass:"counter-text_title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }